document.addEventListener("DOMContentLoaded", function(){ // Handler when the DOM is fully loaded
	////////////////////////////////////////////////
	////////////// OPEN / CLOSE MENU ///////////////
	////////////////////////////////////////////////
	let toggle = document.querySelector('.menu__toggle');

	if(toggle != null && toggle != ''){
		toggle.onclick = function () {
			document.body.classList.toggle('page--menu-open');
			toggle.parentNode.classList.toggle('menu--open');
		}
	}
});